import { render } from "./promo-bar.vue.js?vue&type=template&id=6d8b6045!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./promo-bar.vue?vue&type=template&id=6d8b6045"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__